import Lottie from "lottie-react";

const Animation = () => {
  return (
    <div className="section-content pb-10">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Lottie animationData={require("./../../images/animation/write-and-earn.json")} />
          <p>write-and-earn.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/select.json")} />
          <p>write-and-earn.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/earn-while-dine.json")} />
          <p>earn-while-dine.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/rocket.json")} />
          <p>rocket.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/complete-quest.json")} />
          <p>complete-quest.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/filling-survey.json")} />
          <p>filling-survey.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/sorry.json")} />
          <p>sorry.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/message-stars.json")} />
          <p>message-stars.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/goodjob.json")} />
          <p>goodjob.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/celebration.json")} />
          <p>celebration.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/double-arrow.json")} />
          <p>double-arrow.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/eating-salad.json")} />
          <p>eating-salad.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/withdraw.json")} />
          <p>withdraw.json</p>
        </div>
        <div>
          <Lottie animationData={require("./../../images/animation/critical-feedback.json")} />
          <p>critical-feedback.json</p>
        </div>
      </div>
    </div>
  );
};

export default Animation;
